/* eslint-disable @typescript-eslint/no-namespace */
import { Dispatch } from 'redux';

export namespace Login {
  export type State = 'USER' | 'ADMIN';

  enum ActionType {
    SET = 'SET_LOGIN',
  }

  interface SetAction {
    type: ActionType.SET;
    login: State;
  }

  export type Action = SetAction;

  export const actions = {
    set: (login: State) => (dispatch: Dispatch<SetAction | any>) => {
      dispatch({
        type: ActionType.SET,
        login,
      });
    },
  };

  export function reducer(state: State = null, action: Action): State {
    switch (action.type) {
      case ActionType.SET:
        return action.login;
      default:
        return state;
    }
  }
}
